import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-box',
  template: ''
})
export class DialogBoxComponent extends ComponentBase implements OnInit {

  ngOnInit(): void {
    const title = this.getAttributeValue('title');
    const message = this.getAttributeValue('message');
    const type = this.getAttributeValue('type') as any;

    if (title && message) {
      Swal.fire(title, message, type);
    }
  }

  private getAttributeValue(key: string): string {
    return this.attribute?.attributes?.find(attr => attr.key.toLowerCase() === key)?.value || '';
  }
}